// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__hAdNh","skills__container":"Skills_skills__container__4MIp8"};